export function StepMiddleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M0 0H16L24 8L16 16H0L8 8L0 0Z' fill='currentColor' />
    </svg>
  )
}
